import { render, staticRenderFns } from "./qwik_rvpallocation.vue?vue&type=template&id=7c9328b3&"
import script from "./qwik_rvpallocation.vue?vue&type=script&lang=js&"
export * from "./qwik_rvpallocation.vue?vue&type=script&lang=js&"
import style0 from "./qwik_rvpallocation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports